/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Vs_Yaml_Xml_Faq_Q2Inputs */

const en_guide_json_vs_yaml_xml_faq_q2 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which format is fastest to parse?`)
};

const ko_guide_json_vs_yaml_xml_faq_q2 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`어떤 포맷이 파싱이 가장 빠른가요?`)
};

const ja_guide_json_vs_yaml_xml_faq_q2 = /** @type {(inputs: Guide_Json_Vs_Yaml_Xml_Faq_Q2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最も速くパースできるフォーマットはどれですか？`)
};

/**
* | output |
* | --- |
* | "Which format is fastest to parse?" |
*
* @param {Guide_Json_Vs_Yaml_Xml_Faq_Q2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_vs_yaml_xml_faq_q2 = /** @type {((inputs?: Guide_Json_Vs_Yaml_Xml_Faq_Q2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Vs_Yaml_Xml_Faq_Q2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_vs_yaml_xml_faq_q2(inputs)
	if (locale === "ko") return ko_guide_json_vs_yaml_xml_faq_q2(inputs)
	return ja_guide_json_vs_yaml_xml_faq_q2(inputs)
});